module.exports = __webpack_public_path__ + "static/img/home_logo_old.21af1b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_logo_old.png
// module id = OK2H
// module chunks = 3